// extracted by mini-css-extract-plugin
module.exports = {"list":"list_list__7_2gr","listItem":"list_listItem__UTPBt"};